import { render, staticRenderFns } from "./ReturnGoodsLineChart.vue?vue&type=template&id=2c4a5238"
import script from "./ReturnGoodsLineChart.vue?vue&type=script&lang=js"
export * from "./ReturnGoodsLineChart.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/zippo-mdm-vue-prd/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2c4a5238')) {
      api.createRecord('2c4a5238', component.options)
    } else {
      api.reload('2c4a5238', component.options)
    }
    module.hot.accept("./ReturnGoodsLineChart.vue?vue&type=template&id=2c4a5238", function () {
      api.rerender('2c4a5238', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/dashboard/admin/components/ReturnGoodsLineChart.vue"
export default component.exports